import { FormControl } from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';
import { SwitchGroup, SwitchGroupOptionType } from '~/components/SwitchGroup';
import { VIEW_OPTIONS, VIEW_OPTIONS_TRACK } from '~/constants';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';
import { VIEW_OPTIONS_ICON } from '~/screens/SearchContent/SearchContent.constants';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';

export const ContentSearchFilterView: React.FC<
  IContentSearchComponentProps
> = ({
  filters: { view = VIEW_OPTIONS.grid },
  onChange,
  order,
  trackId,
  isDisabled,
}) => {
  const options: SwitchGroupOptionType[] = useMemo(
    () => [
      {
        icon: VIEW_OPTIONS_ICON[VIEW_OPTIONS.grid],
        isDefault: true,
        value: VIEW_OPTIONS.grid,
        dataHeapTrack: trackId + '-' + VIEW_OPTIONS_TRACK[VIEW_OPTIONS.grid],
      },
      {
        icon: VIEW_OPTIONS_ICON[VIEW_OPTIONS.list],
        value: VIEW_OPTIONS.list,
        dataHeapTrack: trackId + '-' + VIEW_OPTIONS_TRACK[VIEW_OPTIONS.list],
      },
    ],
    [trackId],
  );

  const handleChange = useCallback(
    (value: string) =>
      onChange({
        [CONTENT_SEARCH_PARAMS.view]: value,
      }),
    [onChange],
  );

  return (
    <FormControl
      display="inline-flex"
      width="auto"
      alignItems="center"
      order={order}
      pointerEvents={isDisabled ? 'none' : 'auto'}
    >
      <SwitchGroup
        name="Select View"
        value={view}
        options={options}
        onChange={handleChange}
      />
    </FormControl>
  );
};
